import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabPanel, TabContext } from '@material-ui/lab';
import { Paper, Tabs, Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import TabsStyled from '@commonClient2/components/TabsStyled';
import SetupList from '../SetupList';
import AwardingRules from '../AwardingRules';
import {
    AdminRoutesDictionary, handlePageOptionSelected, tabsOptions,
} from '../App/App.service';

const a11yProps = (index) => ({ id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}` });

/** @param {string} currentPath */
const isMatchAwardingRoute = (currentPath) => currentPath.toLowerCase().match(/\/admin\/awardingrules/);

const Dashboard = () => {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'admin.common' });
    const navigate = useNavigate();
    const location = useLocation();

    const initialSelectedTab = isMatchAwardingRoute(location.pathname)
        ? tabsOptions.AwardingRules
        : tabsOptions.BidSetups;

    const [selectedTab, setSelectedTab] = useState(initialSelectedTab);
    const adminTabs = [
        {
            id: tabsOptions.BidSetups,
            label: t('manageRuleSets'),
        },
        {
            id: tabsOptions.AwardingRules,
            label: t('awardingRules'),
        },
    ];

    return (
        <>
            <div className="admin-tabs-container">
                <TabsStyled>
                    <TabContext value={selectedTab.toString()}>
                        <div className="admin--dashboard-tabs-container">
                            <Paper square>
                                <Tabs
                                    indicatorColor="primary"
                                    onChange={(_, id) => {
                                        setSelectedTab(id);
                                        handlePageOptionSelected(navigate)(id);
                                        // window.history.replaceState(null, '', AdminRoutesDictionary[id]);
                                    }}
                                    textColor="primary"
                                    aria-label="admin tabs"
                                    value={selectedTab}
                                >
                                    {
                                        adminTabs.map((x, index) => (
                                            <Tab
                                                key={`${x.id}_${x.label}`}
                                                label={x.label}
                                                {...a11yProps(index)}
                                            />
                                        ))
                                    }
                                </Tabs>
                            </Paper>
                        </div>
                        <TabPanel value="0">
                            <SetupList />
                        </TabPanel>
                        <TabPanel value="1">
                            <AwardingRules />
                        </TabPanel>
                    </TabContext>

                </TabsStyled>
            </div>
        </>
    );
};

export default Dashboard;
